import React, {PureComponent} from 'react'
import withStyles from '@mui/styles/withStyles';
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from '@mui/icons-material/Close';
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";
import DialogContent from "@mui/material/DialogContent";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import {UrlBuilder} from "../../../core/url/UrlBuilder";
import Box from "@mui/material/Box";
import {GraphQLQueryBuilder} from "../../../core/url/GraphQLQueryBuilder";
import MeasurementLogsTable from "./MeasurementLogsTable";
import LineGraph from "../../graphs/LineGraph";
import {UserContext} from "../../../core/UserContext";
import {withRouter} from "../../../hooks/withRouter";
import {red} from '@mui/material/colors';
import Avatar from "@mui/material/Avatar";
import {ColorPicker} from "../../../core/colors/ColorPicker";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

const useStyles = theme => ({
	title: {
		marginLeft: theme.spacing(1),
		flex: 100,
	},
	container: {
		width: '100%',
		padding: 0,
		backgroundColor: theme.palette.background.default,
	},
	grow: {
		flexGrow: 1,
	},
	'@keyframes flicker': {
		from: {
			opacity: 1,
		},
		to: {
			opacity: 0.4,
		},
	},
	flicker: {
		animationName: '$flicker',
		animationDuration: '1000ms',
		animationIterationCount: 'infinite',
		animationDirection: 'alternate',
		animationTimingFunction: 'ease-in-out',
		color: red[300],
	},
});

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

class MeasurementDetailBloop extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			measurement: this.props.measurement,
			isLoading: false,
			isOpen: this.props.isOpen,
			toastNotificationMessage: null,
		};
	}

	componentWillReceiveProps(nextProps, nextContext) {
		this.setState({
			measurement: nextProps.measurement,
			isOpen: nextProps.isOpen,
		});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		window.onpopstate = e => {
			this.props.closeSelfFunc();
		}
	}

	closeToastNotification = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		this.setState({
			toastNotificationMessage: null,
		});
	};

	refresh = async (withMessage = null) => {
		this.setState({
			isLoading: true
		});

		await fetch(UrlBuilder.graphql, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: GraphQLQueryBuilder.fullMeasurements(this.state.measurement.id),
		})
			.then(res => res.json())
			.then(res => {
				let measurement = res['data']['measurements'][0] ?? this.state.measurement;
				this.props.updateParentMeasurement(measurement);
				this.setState({
					isLoading: false,
					toastNotificationMessage: withMessage,
				});
			});
	}

	getLineGraphData = () => {
		let x = [];
		let y = [];

		this.state.measurement.logs.forEach(log => {
			x.push((new Date(log.dateCreated)).toLocaleDateString());
			y.push(log.value);
		});

		return {
			x: x.reverse(),
			y: y.reverse(),
			label: this.state.measurement ? this.state.measurement.name : ''
		};
	}

	formatNumber = (num) => {
		return parseFloat(num.toFixed(2));
	}

	getTrendInfo = () => {
		const logs = this.state.measurement?.logs;
		if (!logs || logs.length < 2) return null;

		const latest = logs[0].value;
		const previous = logs[1].value;
		const diff = this.formatNumber(latest - previous);
		const pct = previous !== 0 ? this.formatNumber((diff / Math.abs(previous)) * 100) : null;
		const sign = diff > 0 ? '+' : '';

		if (diff > 0) return { icon: <TrendingUpIcon sx={{ fontSize: 18 }} />, diff: `${sign}${diff}`, pct: pct !== null ? `${sign}${pct}%` : null, color: 'success.main' };
		if (diff < 0) return { icon: <TrendingDownIcon sx={{ fontSize: 18 }} />, diff: `${diff}`, pct: pct !== null ? `${diff < 0 ? '' : ''}${pct}%` : null, color: 'error.main' };
		return { icon: <TrendingFlatIcon sx={{ fontSize: 18 }} />, diff: 'No change', pct: null, color: 'text.secondary' };
	}

	render() {
		const {classes} = this.props;
		const measurement = this.state.measurement;
		const logs = measurement?.logs || [];
		const latestValue = logs.length > 0 ? logs[0].value : null;
		const trend = this.getTrendInfo();

		return (
			<Dialog fullScreen open={this.state.isOpen} onClose={this.props.closeSelfFunc} TransitionComponent={Transition}>
				<AppBar position={"relative"} enableColorOnDark>
					<Toolbar variant={"dense"}>
						{measurement && (
							<Avatar sx={{
								bgcolor: measurement.color || ColorPicker.pick(measurement.name),
								width: 28,
								height: 28,
								fontSize: 13,
								fontWeight: 600,
							}}>
								{measurement.name.charAt(0).toUpperCase()}
							</Avatar>
						)}
						<Typography variant="h6" noWrap className={classes.title}>
							{measurement?.name}
						</Typography>

						{this.context.user && this.context.user.activeWorkout ?
							<IconButton edge="end" size="large">
								<RadioButtonCheckedIcon onClick={() => this.context.openActiveWorkoutBloop(true)} className={classes.flicker}/>
							</IconButton> : null
						}

						<div className={classes.grow}/>

						<IconButton size={"small"} color="inherit" onClick={this.props.closeSelfFunc} aria-label="close">
							<CloseIcon/>
						</IconButton>
					</Toolbar>
				</AppBar>

				<DialogContent className={classes.container}>
					<Container className={classes.container}>
						{measurement && (
							<>
								{latestValue !== null && (
									<Box sx={{
										pt: 2.5,
										pb: 1.5,
										px: 1,
									}}>
										<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, letterSpacing: 0.5 }}>
											CURRENT
										</Typography>
										<Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mt: 0.25 }}>
											<Typography variant="h3" sx={{ fontWeight: 700, lineHeight: 1.1 }}>
												{this.formatNumber(latestValue)}
											</Typography>
											{trend && (
												<Box sx={{
													display: 'inline-flex',
													alignItems: 'center',
													gap: 0.5,
													bgcolor: (theme) => trend.color === 'success.main'
														? (theme.palette.mode === 'dark' ? 'rgba(102,187,106,0.12)' : 'rgba(102,187,106,0.1)')
														: trend.color === 'error.main'
															? (theme.palette.mode === 'dark' ? 'rgba(239,83,80,0.12)' : 'rgba(239,83,80,0.1)')
															: 'action.hover',
													color: trend.color,
													borderRadius: 1,
													px: 0.75,
													py: 0.25,
												}}>
													{trend.icon}
													<Typography variant="body2" sx={{ fontWeight: 600, fontSize: 13 }}>
														{trend.diff}{trend.pct ? ` (${trend.pct})` : ''}
													</Typography>
												</Box>
											)}
										</Box>
										<Typography variant="caption" sx={{ color: 'text.secondary', mt: 0.5, display: 'block' }}>
											{logs.length} log{logs.length !== 1 ? 's' : ''} recorded
										</Typography>
									</Box>
								)}

								{logs.length > 0 && (
									<Box sx={{ pb: 1 }}>
										<LineGraph data={this.getLineGraphData()}/>
									</Box>
								)}

								<MeasurementLogsTable
									measurement={measurement}
									isLoading={this.state.isLoading}
									refreshParentFunc={this.refresh}
								/>
							</>
						)}
					</Container>
				</DialogContent>

				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					open={this.state.toastNotificationMessage !== null}
					autoHideDuration={1500}
					onClose={this.closeToastNotification}
					message={this.state.toastNotificationMessage}
					action={
						<React.Fragment>
							<IconButton size="small" aria-label="close" color="inherit" onClick={this.closeToastNotification}>
								<CloseIcon fontSize="small" />
							</IconButton>
						</React.Fragment>
					}
				/>
			</Dialog>
		);
	}
}

MeasurementDetailBloop.contextType = UserContext;

export default withStyles(useStyles)(withRouter(MeasurementDetailBloop));
